module.exports = __webpack_public_path__ + "media/personal_finance/Personal-Finance_image_top-77c9a32a.jpg";